import { BeneficiaryStatus, BeneficiaryStatusInProduct } from '../../types/voucher-beneficiaries';
function mapStatusInProduct(statusInProduct) {
    return statusInProduct === BeneficiaryStatusInProduct.ACTIVE
        ? BeneficiaryStatusInProduct.ACTIVE
        : BeneficiaryStatusInProduct.INACTIVE;
}
export function mapEmissorBeneficiaryToCollaborator(beneficiary) {
    const bond = beneficiary.bond;
    return {
        id: beneficiary.id,
        jobRole: bond?.jobRole ?? null,
        document: beneficiary.document,
        firstName: beneficiary.firstName,
        lastName: beneficiary.lastName,
        employeeCode: bond?.employeeCode ?? '',
        deliveryLocationId: '',
        birthDate: beneficiary.birthDate ? new Date(beneficiary.birthDate) : new Date(0),
        phoneNumber: '',
        email: bond?.email ?? '',
        status: beneficiary.isWorking ? BeneficiaryStatus.WORKING : BeneficiaryStatus.INACTIVE,
        employeeId: bond?.employeeId ?? '',
        isNew: beneficiary.isNew,
        productValue: 0,
        statusInProduct: mapStatusInProduct(beneficiary.statusInProduct),
        productDaysQuantity: 0,
        productDiscountValue: 0,
        cardIssued: beneficiary.cardIssued,
        contractType: bond?.contractType ?? undefined,
        costCenter: bond?.costCenter ?? undefined,
        department: bond?.department ?? undefined,
        category: bond?.category ?? undefined,
        employmentBond: bond?.employmentBond ?? undefined,
        branch: bond?.branch ?? undefined,
        union: bond?.union ?? undefined,
        hireDate: bond?.hireDate ?? null,
    };
}
export function mapEmissorBeneficiariesToCollaborators(beneficiaries) {
    return beneficiaries.map(beneficiary => mapEmissorBeneficiaryToCollaborator(beneficiary));
}
